export default "__VITE_ASSET__c976f5e3__"